import { StatChartBaseProps, StatChartData } from '@/components';
import { ContentDimensions, StatChartSpec } from '@/core';
import { OptionsEditorProps, PropToSpecMapping } from '@/plugin-system';
import { StatChartPanelProps } from './StatChartPanel';

export type StatChartOptionsEditorProps = OptionsEditorProps<StatChartSpec>;

export function createInitialStatChartOptions(): StatChartSpec {
  return {
    unit: {
      kind: 'Decimal',
    },
  };
}

/**
 * Defines a mapping between a chart's props and its equivalent dashboard spec.
 * Keys represent the chart's props, while values correspond to the spec.
 */
export const STAT_CHART_PROP_TO_SPEC_MAPPING: PropToSpecMapping<StatChartPanelProps, StatChartSpec> = {
  calculation: 'calculation',
  unit: 'unit',
  thresholds: 'thresholds',
  sparkline: 'sparkline',
  valueFontSize: 'value_font_size',
  seriesNameFontSize: 'series_name_font_size',
  messageFontSize: 'message_font_size',
  showSeriesName: 'show_series_name',
};

export enum StatChartColorScheme {
  THRESHOLDS = 'thresholds',
  DEFAULT = 'default',
}

export const STAT_CHART_DATA_TYPES: Array<'SingleValue' | 'SingleValueTimeSeries'> = [
  'SingleValue',
  'SingleValueTimeSeries',
];

export type CombinedStatChartData = StatChartData & Pick<StatChartBaseProps, 'color' | 'sparkline' | 'comparison'>;

export type StatChartPanelLoadedProps = Omit<StatChartPanelProps, keyof ContentDimensions> & {
  contentDimensions: ContentDimensions;
};

export const STAT_CHART_MIN_WIDTH = 100;
